import { BillingInterval } from './types';

export function formatMoney(amount: number, currency: string): string {
  const value = Number.isFinite(amount) ? amount : 0;
  return `${currency} ${value.toLocaleString(undefined, {
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  })}`;
}

export function formatInterval(interval: BillingInterval, count: number): string {
  const unit = interval === 'YEAR' ? 'year' : 'month';
  return count === 1 ? `per ${unit}` : `every ${count} ${unit}s`;
}

export function formatDate(value: string | null | undefined, withTime = false): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return withTime ? date.toLocaleString() : date.toLocaleDateString();
}

/** Fallback label for plan codes that are not in the catalogue (e.g. very old data). */
export function humanizeCode(code: string | null | undefined): string {
  if (!code) return 'N/A';
  return code
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
